// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var ERoomCount;
(function (ERoomCount) {
  ERoomCount["Bed"] = "bed";
  ERoomCount["FiveRoom"] = "fiveRoom";
  ERoomCount["FourRoom"] = "fourRoom";
  ERoomCount["Large"] = "large";
  ERoomCount["OneRoom"] = "oneRoom";
  ERoomCount["OpenPlan"] = "openPlan";
  ERoomCount["Room"] = "room";
  ERoomCount["Share"] = "share";
  ERoomCount["Studio"] = "studio";
  ERoomCount["ThreeRoom"] = "threeRoom";
  ERoomCount["TwoRoom"] = "twoRoom";
})(ERoomCount || (ERoomCount = {}));